
import { Component, Vue, Watch } from "vue-property-decorator";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import ModalMessageApp from "@/components/ModalMessageApp.vue";
import LeadService from "@/services/leadService";
import LeadTabulationService from "@/services/lead/LeadTabulationService";
import WhatsappService from "@/services/integration/WhatsappService";
import AppService from "@/services/integration/AppService";
import ChannelService from "@/services/lead/ChannelService";
import saasService from "@/services/SaasService";
import SmsService from "@/services/integration/SmsService";
import PabxService from "@/services/integration/PabxService";
import ActionService from "@/services/lead/ActionService";
import DateRangePicker from "vue2-daterange-picker";
import vSelect from "vue-select";
import { HumanizeDurationLanguage, HumanizeDuration} from "humanize-duration-ts";
import UserService from "@/services/auth/UserService";
import { mapGetters } from "vuex";
import axios from 'axios'
import { dateFilter, percentageFilter, currencyFilter } from "@/utils/filters";
import { Money } from "v-money";
import WidgetMultiStepFormModalBV from "@/components/widget/WidgetMultiStepFormModalBV.vue";

import "datatables.net-colreorder-dt";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-fixedcolumns-bs4";
import "datatables.net-buttons/js/buttons.html5";

var capitalize = require("capitalize");

@Component({
  name: 'LeadsDefault',

  components: {
    LayoutDefault,
    DateRangePicker,
    vSelect,
    ModalMessageApp,
    Money,
    WidgetMultiStepFormModalBV,
  },

  filters: {
    date: dateFilter,
    percentage: percentageFilter,
    currency: currencyFilter
  },

  computed: {
    ...mapGetters('auth', ['allowedFeature'])
  }
})
export default class Leadlist extends Vue {
  private allowedFeature: any;

  /**
   * @type Instance
   * For manager data on lead backend routes
   */
  private leadService = new LeadService();

  /**
   * @type Instance
   * For manager data on whatsapp service backend routes
   */
  private whatsappService = new WhatsappService();

  /**
   * @type Instance
   * For manager data on sms service backend routes
   */
  private smsService = new SmsService();

  /**
   * @type Instance
   * For manager data on channel service backend routes
   */
  private channelService = new ChannelService();

  /**
   * @type Instance
   * For manager data on channel service backend routes
   */
  private actionService = new ActionService();
  /**
   *
   * @type Instance
   * For manager data on channel service backend routes
   */
  private appService = new AppService();

  /**
   * @type Boolean
   * help control validation export lead to pabx
   */
  private PabxValidation: boolean = false;

  /**
   * @type Object
   * Data list lead from return backend
   */
  private listLead: any;

  /**
   * @type Array
   * List attributes on filter platform custom
   */
  private listAttribute: any = [
    {
      name: "",
      label: "",
    },
  ];

 private loadingMetric: boolean = false;

  private get getLoading() {
    return !this.loadingMetric ? false : true;
  }

  /**
   * @type Object
   * contains data from run filter on list leads
   */
  private filter: any = {
    attribute: "",
    attrContent: "",
    date: {
      startDate: "",
      endDate: ""
    },
    id_status: [],
    id_status_contact: [],
    id_action: [],
    referer: "",
    origin: "",
    plugin: "",
    export: "",
    notWorked: null as null|{ label:string, startDate:string, endDate: string },
    checkboxFilters: [] as string[]
  };

  private cacheFilter() {
    localStorage.setItem(
      "checkbox-filter",
      JSON.stringify(this.filter.checkboxFilters)
    );

    localStorage.setItem(
      "attribute-filter",
      JSON.stringify(this.filter.attribute)
    );

    this.filter.attrContent = !["phone", "home_phone", "phone3", "phone4", "phone5"].includes(this.filter.attribute) ? this.filter.attrContent.replace('+55', '') : this.filter.attrContent;

  }

  /**
   * @type Object
   * insert new lead
   */
  private lead: any = {
    name: null,
    phone: null,
    email: null,
    cpf: null,
    details: null,
    plugin: "manual",
    origin: "dashboard",
    is_hot_lead: false,
    id_platform: this.$auth.user().id_platform,
    action: null,
  };

  private leadAllFields: any = {};
  private leadHistory: any = [];
  private deleteIdleadHistory: any;
  private resetIdlead: any;
  private modalLead: any = "";
  private modalLeadHistory: any = "";
  private modalLeadMessage: any = "";
  private modalName: any = "";
  private modalStatus: any = "";
  private exportEvenIfAlreadyContactedToday: boolean = false;
  private overflow:any = null;
  private user_squad:any;
  private userSelected:any = null;
  private getMessageResponse:any = null;
  private selectedMessageResponse:any = null;
  private dispatcher:boolean = false;
  /**
   * @type boolean
   * Help to control error message
   */
  private showDangerAlert: boolean = false;
  private dangerAlertMessage: string = "";

  /**
   * @type boolean
   * Help to control success message
   */
  private showSuccessAlert: boolean = false;
  private successAlertMessage: string = "";

  /**
   * @type object
   * Help control error form for send or not
   */
  private leadFormError: object = {
    name: { state: null, message: "Campo obrigatório" },
    phone: { state: null, message: "Campo obrigatório" },
    email: { state: null, message: "Email inválido" },
    cpf: { state: null, message: "CPF inválido" },
    order: { state: null, message: "Numero de pedido inválido" },
    details: { state: null, message: "Campo obrigatório. Mínimo de 10 caracteres." }
  };

  /**
   * @type
   * Help to control show loading icon
   */
  private loading: boolean = false;
  private modalLoading: boolean = false;

  /**
   * @type Any
   * get date select in ranger filter modal
   */
  private dateRange: any = {
    startDate: "",
    endDate: "",
  };

  /**
   * @type Array
   * set options status on filter modal
   */
  private statusOptions = [
    { code: 1, label: "Lead" },
    { code: 4, label: "Atendimento" },
    { code: 50, label: "Trabalhado" },
    { code: 15, label: "Agendamento" },
    { code: 3, label: "Conversão" },
    { code: 16, label: "Recusa" },
    { code: 8, label: "Auto conversão" },
    { code: 23, label: "Improdutivo" },
  ];

  /**
   * @type Array
   * set options channel status on filter modal
   */
  private channelStatus = [];

  /**
   * @type Array
   * set options channel platform on filter modal
   */
  private channelPlatform = [
    { id_channel: null, label: "Não exportado", delay_export: 0 },
  ];

  private whatsappChanel:any;
  private smsChannel:any;


  /**
   * set options and models auto attendeces
   */
  private channelAttendeceOptions:any = [];
  private tabulationsAttendeceOptions:any = [];
  private channelAutoAttendance:any = null;
  private tabulationAutoAttendance:any = {};

  /** Not worked filter options */
  private notWorkedOptions = [
    { label: "Hoje", value: 0 },
    { label: "Nos últimos 7 dias", value: 7 },
    { label: "Nos últimos 15 dias", value: 15 },
    { label: "Nos últimos 30 dias", value: 30 },
    { label: "Nunca", value: 3650 },
  ];

  /**
   * @type Array
   * set options action platform on filter modal
   */
  private actionPlatform = [];

  /**
   * @type Array
   * Define columns from datatables
   */
  private columns = [
    {
      data: "cl-wc-id_lead",
      name: "cl-wc-id_lead",
      title: "Clever ID",
      orderable: true,
    },
    {
      data: "clh_lead-wc-id_lead_history",
      name: "clh_lead-wc-id_lead_history",
      title: "History ID",
      orderable: false,
      searchable: false,
      visible: false,
    },
    {
      data: "name",
      name: "name",
      title: "Nome",
      orderable: true,
      defaultContent: "--",
      searchable: true,
    },
    {
      data: "phone",
      name: "phone",
      title: "Telefone",
      orderable: true,
      defaultContent: "--",
      visible: this.$auth.user().platform_name !== 'bv-fgts-app' || this.$auth.user().profile === 'admin'
    },
    {
      data: "email",
      name: "email",
      title: "E-mail",
      orderable: true,
      defaultContent: "--",
    },
    {
      data: "details",
      name: "details",
      title: "Detalhes",
      orderable: false,
      defaultContent: "--",
    },
    {
      data: "clh_lead-wc-created_at",
      name: "clh_lead-wc-created_at",
      title: "Data inserção",
      orderable: true,
    },
    {
      data: "cs_status-wc-label",
      name: "cs_status-wc-label",
      title: "Status",
      orderable: true,
    },
    {
      data: "clh_last-wc-fk_id_status",
      name: "clh_last-wc-fk_id_status",
      title: "id status",
      orderable: false,
      defaultContent: "--",
      searchable: false,
      visible: false,
    },
    {
      data: "clh_last-wc-fk_id_action",
      name: "clh_last-wc-fk_id_action",
      title: "Ação",
      orderable: false,
      defaultContent: "--",
      searchable: false,
      visible: false,
    },
    {
      data: "product",
      name: "product",
      title: "Produto",
      orderable: false,
      defaultContent: "--",
    },
    {
      data: "clh_last-wc-created_at",
      name: "clh_last-wc-created_at",
      title: "Data ult. status",
      orderable: true,
      defaultContent: "--",
    },
    {
      data: "cl_export-wc-worked_at",
      name: "cl_export-wc-worked_at",
      title: "Data ult. trabalhado",
      orderable: true,
      defaultContent: "--",
    },
    {
      data: "clh_lead-wc-plugin",
      name: "clh_lead-wc-plugin",
      title: "Plugin",
      orderable: false,
      defaultContent: "--",
    },
    {
      data: "cl_export-wc-fk_id_channel",
      name: "cl_export-wc-fk_id_channel",
      defaultContent: "--",
      visible: false,
    },
    {
      data: "clh_lead-wc-export_date",
      name: "clh_lead-wc-export_date",
      defaultContent: "--",
      visible: false,
    },
    {
      data: "clh_last-wc-id_lead_history",
      name: "clh_last-wc-id_lead_history",
      title: "Last History ID",
      orderable: false,
      searchable: false,
      visible: false,
    },
  ];
  private adminOnlyColumns: string[] = [];

  /**
   * @type Array
   * Config columns visible on datatables
   */

  // hide phone for bv-fgts-app
  private columnsVisible = this.$auth.user().platform_name === 'bv-fgts-app'
    && this.$auth.user().profile !== 'admin'
    ? [0, 2, 4, 5, 6, 7, 9, 10, 11, 12]
    : [0, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12]

  private get columnsVisibleChunck() {
    let perChunk = 2; // items per chunk
    let result = this.columnsVisible.reduce((resultArray: any, item, index) => {
      const chunkIndex = Math.floor(index / perChunk);

      if (!resultArray[chunkIndex]) {
        resultArray[chunkIndex] = []; // start a new chunk
      }

      resultArray[chunkIndex].push(item);

      return resultArray;
    }, []);
    return result;
  }

  /**
   * @type Array
   * Help for control attributes show in display and query database
   */
  private attributesVisible = ["email", "name", "phone", "details", "product"];

  /**
   * @type Array
   * Set config for buttons datatable
   */
  private buttons: any = [];

  private hDuration: HumanizeDuration = new HumanizeDuration(
    new HumanizeDurationLanguage()
  );

  private totalLeads: number = 0;

  private exportFormat: string = "csvHtml5";

  private limitDateAttendance  = this.$moment().add(-1, 'day').format('YYYY-MM-DD HH:mm:ss');
  private date_scheduling;

  private dateScheduling = {
    startDate: "",
    endDate: ""
  }

  @Watch("dateScheduling.startDate")
  onChangeRangeScheduling(value: any, _oldValue: any) {
    this.date_scheduling = value;
  }


  private get timeStatusConvertion() {
    if (
      this.leadHistory &&
      this.leadHistory[this.leadHistory.length - 1].created_at &&
      this.leadHistory[this.leadHistory.length - 1].name ==
        "lead_finished_sale" &&
      this.leadAllFields &&
      this.leadAllFields.date &&
      (this.$auth.user().profile === "admin" || this.$auth.user().profile === 'management')
    ) {
      let calcDiff = (this.$moment(this.leadAllFields.date) as any).diff(
        this.$moment(this.leadHistory[this.leadHistory.length - 1].created_at)
      );

      return this.hDuration.humanize(calcDiff, {
        language: "pt",
        units: ["y", "mo", "d", "h", "m", "s"],
        round: true,
      });
    }
    return 0;
  }

  private get dateConversion() {
    if (
      this.leadHistory &&
      this.leadHistory[this.leadHistory.length - 1].created_at &&
      this.leadHistory[this.leadHistory.length - 1].name == "lead_finished_sale"
    ) {
      return this.leadHistory[this.leadHistory.length - 1].created_at;
    }
    return 0;
  }

  /**
   * Method created life cycle
   */
  private async created() {
    let self = this;

    axios.defaults.headers.common['Authorization'] = `Bearer ${this.$auth.token()}`;

    /** Query filters */
    let keys = Object.keys(this.$route.query);
    let n = keys.length;
    let queryLowerCase: {[key: string]: any} = {};
    while (n--) {
      let key = keys[n];
      queryLowerCase[key.toLowerCase()] = this.$route.query[key];
    }

    // Lead ID
    if (queryLowerCase.cleverid) {
      this.filter.attribute = "cl-wc-id_lead";
      this.filter.attrContent = queryLowerCase.cleverid;
    }
    // Group by history
    if (typeof queryLowerCase.groupbyhistory !== 'undefined') {
      if (!this.filter.checkboxFilters.includes('groupByHistory'))
        this.filter.checkboxFilters.push('groupByHistory');
    }
    // Action ID
    if (queryLowerCase.actionid)
        this.filter.id_action = Array.isArray(queryLowerCase.actionid) ? queryLowerCase.actionid.map(Number) : [Number(queryLowerCase.actionId)];
    /** End of query filters */

    //(window as any).JSZip = JSZip;

    // get attributes from platform
    this.leadService
      .attribute(this.$auth.user().id_platform)
      .then((response: any) => {
        this.listAttribute = JSON.parse(JSON.stringify(response));
        this.listAttribute.forEach((attr, key) => {
          if (
            attr.id_platform != null &&
            attr.id_platform > 0 &&
            attr.is_internal === null
          ) {
            if (attr.name == "platform_lead_id") {
              this.listAttribute[key].label =
                this.$auth.user().platform_name[0].toUpperCase() +
                this.$auth.user().platform_name.slice(1) +
                " ID";
              this.columns.push({
                data: attr.name,
                name: attr.name,
                title:
                  this.$auth.user().platform_name[0].toUpperCase() +
                  this.$auth.user().platform_name.slice(1) +
                  " ID",
                orderable: true,
                defaultContent: "--",
                searchable: true,
                visible: false,
              });
            } else {
              this.columns.push({
                data: attr.name,
                name: attr.name,
                title: attr.label,
                orderable: true,
                defaultContent: "--",
                searchable: true,
                visible: false,
              });
            }
            this.columnsVisible.push(this.columns.length - 1);
          }
        });
        this.listAttribute.push({ name: "cl-wc-id_lead", label: "Clever ID" });

        // add attributes retrict for internal profiles
        this.listAttribute.forEach((element) => {
          if (element.is_internal && element.is_internal.includes(this.$auth.user().profile)) {
            this.columns.push({
              data: element.name,
              name: element.name,
              title: element.label,
              orderable: false,
              defaultContent: "--",
              searchable: false,
              visible: false,
            });
            this.columnsVisible.push(this.columns.length - 1);
          }
        });

        this.createDataTable(self);
      });

    this.$watch(
      () => this.$store.getters["exportToPABX/chunksAmount"],
      this.onExportResponseReceived
    );

    this.channelService.channelStatus().then((response: any) => {
      this.channelStatus = response ? response : [];
    });

    this.channelService.index().then((response: any) => {
      if (response && response.length > 0) {
        this.channelPlatform = this.channelPlatform.concat(response);
        this.whatsappChanel = this.channelPlatform.find((channel: any) => { return channel.name == "whatsapp"});
        this.smsChannel = this.channelPlatform.find((channel: any) => { return channel.name == 'sms'});
        this.channelAttendeceOptions =
        ["dokcalcados-ortope", "bv-prevent-churn"].includes(this.$auth.user().platform_name) ?
            this.channelPlatform.filter((e) => e.label != "Não exportado") :
            this.channelPlatform.filter((e) => e.label != "Não exportado" && e.label != "App")
      }
    });

    this.actionService.indexStatus("action_active").then(
      (result) => {
        this.actionPlatform = result.body;
      },
      (error) => {
        console.log(error);
      }
    );
  }


   private get mask(){
    if (["phone", "home_phone", "phone3", "phone4", "phone5"].includes(this.filter.attribute))
      return ['+55##########', '+55###########']

    if(['date_scheduling', "date_renovation", "date_sale","clh_lead-wc-created_at", "clh_last-wc-created_at", "cl_export-wc-worked_at"].includes(this.filter.attribute))
      return ['##/##/####'];

    if(['cpf'].includes(this.filter.attribute))
      return ['###.###.###-##'];

    if(['cnpj'].includes(this.filter.attribute))
      return ["##.###.###/####-##"]

    return;
   }

  /**
   * Method filter list lead
   */
  private sendFilter() {
    this.listLead.ajax.reload();
    this.hideModal("modal-filter");
  }

  private reloadDatatable() {
    try {
      this.listLead?.ajax?.reload();
    } catch (e) {
      console.error(e);
    }
  }

  /**
   * Method to clerar filters on list lead
   */
  private clearFilter() {
    this.filter.attribute = "";
    this.filter.attrContent = "";
    this.filter.date = {
      startDate: "",
      endDate: ""
    };
    this.filter.id_status = [];
    this.filter.id_action = [];
    this.filter.id_status_contact = [];
    this.filter.referer = "";
    this.filter.origin = "";
    this.filter.plugin = "";
    this.filter.export = "";
    this.filter.notWorked = null;
    this.filter.checkboxFilters = [];
    localStorage.removeItem("attribute-filter");
    localStorage.removeItem("checkbox-filter");

    this.listLead.ajax.reload();
    this.hideModal("modal-filter");
  }

  private mountedFilter(d: any) {

    d.filterAttr = false;
    d.groupByHistory = this.filter.checkboxFilters.includes('groupByHistory');
    d.invalidLeads = false;
    d.id_user = this.$auth.user().id_user;
    d.id_platform = this.$auth.user().id_platform;
    d.platform_attributes = this.listAttribute;
    d.show_attributes = (this.listAttribute.filter((attr:any) => this.attributesVisible.includes(attr.name) ? true : false)).map(e => e.id_lead_attribute)

    d.table_filter_apply = [];
    d.columns.forEach((col, key) => {
      if (col.data == this.filter.attribute) {
          if (this.filter.attrContent && ['date_scheduling', "date_renovation", "date_sale","clh_lead-wc-created_at", "clh_last-wc-created_at", "clh_lead-wc-created_at"].includes(this.filter.attribute))
            this.filter.attrContent = this.$moment(this.filter.attrContent, 'DD/MM/YYYY').format("YYYY-MM-DD");

        if (this.filter.attrContent && ["cpf", "cnpj"].includes(this.filter.attribute))
            this.filter.attrContent = this.filter.attrContent.replaceAll('.', '').replaceAll('-', '').replaceAll('/', '');

        d.columns[key].search.value = this.filter.attrContent;
        d.filterAttr = true;
      }
      // filter date update
      if (
        col.data == "clh_last-wc-created_at" &&
        this.filter.date.startDate &&
        this.filter.date.startDate != ""
      ) {
        d.table_filter_apply.push('clh_last');
        let filterDate: any = [];
        if (this.filter.date.startDate) {
          filterDate.push(
            (this.$moment(this.filter.date.startDate) as any).format(
              "YYYY-MM-DD"
            ) + " 00:00:00"
          );
          filterDate[0] = this.$moment(filterDate[0], "YYYY-MM-DD HH:mm:ss");
          filterDate[0] = this.$moment
            .utc(filterDate[0])
            .format("YYYY-MM-DD HH:mm:ss");
        }
        if (this.filter.date.endDate) {
          filterDate.push(
            (this.$moment(this.filter.date.endDate) as any).format(
              "YYYY-MM-DD"
            ) + " 24:00:00"
          );
          filterDate[1] = this.$moment(filterDate[1], "YYYY-MM-DD HH:mm:ss");
          filterDate[1] = this.$moment
            .utc(filterDate[1])
            .format("YYYY-MM-DD HH:mm:ss");
        }
        d.columns[key].search.value = filterDate.length > 0 ? filterDate : "";
      }
      // filter status
      if (
        col.data == "clh_last-wc-fk_id_status" &&
        this.filter.id_status.length > 0
      ) {
        d.table_filter_apply.push('clh_last');
        const tmp_id: any = [];
        this.filter.id_status.forEach((status: any) => {
          tmp_id.push(status.code);
        });
        d.columns[key].search.value = tmp_id;
        d.columns[key].search.cond = "OR";
      }
      // filter action
      if (
        col.data == "clh_last-wc-fk_id_action" &&
        this.filter.id_action.length > 0
      ) {
        d.table_filter_apply.push('clh_last');
        const tmp_id: any = [];
        this.filter.id_action.forEach((action: any) => {
          tmp_id.push(action);
        });
        d.columns[key].search.value = tmp_id;
        d.columns[key].search.cond = "OR";
      }
      // filter status contact
      if (
        col.data == "pabxf-wc-idStatusLigacao" &&
        this.filter.id_status_contact.length > 0
      ) {
        d.table_filter_apply.push('pabxf');
        const tmp_id: any = [];
        this.filter.id_status_contact.forEach((channelStatus: any) => {
          tmp_id.push(channelStatus.id_status);
        });
        d.columns[key].search.value = tmp_id;
        d.columns[key].search.cond = "OR";
      }
      // filter referer
      if (col.data == "clh_lead-wc-referer" && this.filter.referer != "") {
        d.table_filter_apply.push('clh_lead');

        d.columns[key].search.value = this.filter.referer;
      }
      // filter origin
      if (col.data == "clh_lead-wc-origin" && this.filter.origin != "") {
        d.table_filter_apply.push('clh_lead');

        d.columns[key].search.value = this.filter.origin;
      }
      // filter plugin
      if (col.data == "clh_lead-wc-plugin" && this.filter.plugin != "") {
        d.table_filter_apply.push('clh_lead');

        d.columns[key].search.value = this.filter.plugin;
      }
      //filter export channel
      if (
        col.data == "cl_export-wc-fk_id_channel" &&
        this.filter.export.length > 0
      ) {
        d.table_filter_apply.push('cl_export');

        const tmp_id: any = [];
        this.filter.export.forEach((channelExport: any) => {
          if (channelExport.id_channel || channelExport.id_channel === null) tmp_id.push(channelExport.id_channel);
        });
        if (tmp_id.length > 0) {
          d.columns[key].search.value = tmp_id;
          d.columns[key].search.cond = "OR";
        }
      }
    });
    if (this.filter.notWorked !== null ) {
      d.table_filter_apply.push('cle_notWorked');
      d.columns[d.columns.length] = {
        data: "cle_notWorked-wc-worked_at",
        name: "cle_notWorked-wc-worked_at",
        title: "notWorked_lead",
        orderable: false,
        defaultContent: "--",
        searchable: false,
        visible: false,
        search:{
          value: [
            this.$moment().startOf('day').subtract(this.filter.notWorked.value, 'day').utc().format("YYYY-MM-DD HH:mm:ss"),
            this.$moment().add(1, 'minute').utc().format("YYYY-MM-DD HH:mm:ss")
          ],
          not: true
        }
      }
    }
    d.table_filter_apply = [...new Set(d.table_filter_apply)];

    if (this.filter.checkboxFilters.includes('onlyMine')){
      d.columns.find(col => col.name === 'cs_user-wc-name').search.value = this.$auth.user().name;
    }

    // Fraud mitigation: display only their own tabulated leads for operators
    if (this.$auth.user().profile === 'operator') {
      d.columns.find(col => col.name === 'cs_user-wc-name').search.value = this.$auth.user().name;
    }

    if(this.filter.checkboxFilters.includes('invalidLeads'))
      d.invalidLeads = true;

    this.filter.id_action.length == 1 ? this.$('.dispatcher-transshipment').show() : this.$('.dispatcher-transshipment').hide();

    return d;
  }

  private get usingNotWorkedFilter() {
    return this.filter.notWorked !== null;
  }

  private get filteringOnlyByLeadStatus() {
    return Array.isArray(this.filter.id_status) && this.filter.id_status.length === 1 && this.filter.id_status[0].code === 1;
  }

  private statusFilterInput() {
    if (this.usingNotWorkedFilter && !this.filteringOnlyByLeadStatus) {
      this.filter.id_status = [this.statusOptions.find(e => e.code === 1)];
    }
  }

  private notWorkedFilterInput() {
    let dateFilterSelected = this.filter.date.startDate !== "" && this.filter.date.endDate !== "";
    let differenceInDays = dateFilterSelected ? (this.$moment(this.filter.date.endDate) as any).diff(this.$moment(this.filter.date.startDate), 'days') : null;

    if (!dateFilterSelected) {
      let today = this.$moment().hour(12).minute(0).second(0);
      this.filter.date.startDate = this.$moment(today).subtract(7, 'days').toDate();
      this.filter.date.endDate = today.toDate();

    } else if (dateFilterSelected && differenceInDays > 7) {
      this.filter.date.startDate = this.$moment(this.filter.date.endDate as Date).subtract(7, 'days').toDate();
    }

    if (!this.filteringOnlyByLeadStatus) {
      this.filter.id_status = [this.statusOptions.find(e => e.code === 1)];
    }
  }

  private dateFilterInput(selectedRange) {
    let differenceInDays = (this.$moment(selectedRange.endDate) as any).diff(this.$moment(selectedRange.startDate), 'days');

    if (this.usingNotWorkedFilter && differenceInDays > 7) {
      this.filter.date.startDate = this.$moment(selectedRange.endDate as Date).subtract(7, 'days').toDate();
      this.filter.date.endDate = selectedRange.endDate;
    }

    if (this.usingNotWorkedFilter && !this.filteringOnlyByLeadStatus) {
      this.filter.id_status = [this.statusOptions.find(e => e.code === 1)];
    }
  }

  private clearDates() {
    this.filter.date = {
      startDate: "",
      endDate: ""
    }
  }

  private async allDataToExport() {
    if (this.listLead.ajax.json() !== undefined) {
      let d = this.mountedFilter(JSON.parse(this.listLead.ajax.params()));

      let pages = 0;
      pages = this.listLead.ajax.json().recordsTotal / 1000;
      if (this.listLead.ajax.json().recordsTotal % 1000 > 0) {
        pages = Math.trunc(pages) + 1;
      }
      this.$store.commit("exportToPABX/setExportsCounterTotal", pages);
      let results: any = [];
      let mergeData: any = [];
      let dataAux = Object.assign({}, d);
      for (let index = 0; index < pages; index++) {
        dataAux.draw = String(index + 1);
        dataAux.start = String(index * 1000);
        dataAux.length = String(1000);

        let response = await this.leadService.datatable(dataAux);
        if (response.status == 200 && response.body) {
          this.$store.commit("exportToPABX/incrementExportsCounterSuccess");
          results.push(response.body);
        } else if (response.status != 200) {
          this.$store.commit("exportToPABX/incrementExportsCounterError");
        }
      }
      for (const key in results) {
        if (results.hasOwnProperty(key)) {
          const element = results[key];
          Array.prototype.push.apply(mergeData, element.data);
        }
      }

      this.listLead.clear();
      this.listLead.rows.add(mergeData);
      this.listLead.draw();

      this.$.fn.dataTable.ext.buttons[this.exportFormat].action.call(
        this.listLead.button(this),
        null,
        this.listLead,
        null,
        this.$.fn.dataTable.ext.buttons[this.exportFormat]
      );
    }
  }

  private get nameState() {
    if (this.lead["name"] != null) {
      this.leadFormError["name"].state =
      this.lead["name"] != null &&
      this.lead["name"] != "" ? true : false;
    }
    return this.leadFormError["name"].state;
  }

  private get phoneState() {
    if (this.lead["phone"] != null) {
      this.leadFormError["phone"].state =
        this.lead["phone"] != null &&
        this.lead["phone"] != "" &&
        this.lead["phone"].length > 12
          ? true
          : false;
    }
    return this.leadFormError["phone"].state;
  }

  private get emailState() {
    // key for platforms where email will not be mandatory
    if (this.lead["email"] == "-") {
      this.leadFormError["email"].state = true;
      return this.leadFormError["email"].state;
    }

    if (this.lead.email != null) {
      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      this.leadFormError["email"].state =
        this.lead["email"].toLowerCase().match(reg) &&
        this.lead["email"] != null &&
        this.lead["email"] != "" ? true : false;
    }
    return this.leadFormError["email"].state;
  }

  private get cpfState() {
    if (this.lead["cpf"] != null && this.lead["cpf"] != "" && this.lead['cpf'].length > 13) {
        this.lead['cpf'] =  this.lead['cpf'].replace(/[\s.-]*/igm, '');
      var sum;
      var rest;
      sum = 0;
      if (this.lead["cpf"] == "00000000000") {
        this.leadFormError["cpf"].state = true;
        return this.leadFormError["cpf"].state;
      }

      for (let i=1; i<=9; i++) {
        sum = sum + parseInt(this.lead["cpf"].substring(i-1, i)) * (11 - i);
      }

      rest = (sum * 10) % 11;

      if ((rest == 10) || (rest == 11))  rest = 0;
      if (rest != parseInt(this.lead["cpf"].substring(9, 10)) ) {
        this.leadFormError["cpf"].state = false;
        return this.leadFormError["cpf"].state;
      }

      sum = 0;
      for (let i = 1; i <= 10; i++) {
        sum = sum + parseInt(this.lead["cpf"].substring(i-1, i)) * (12 - i);
      }

      rest = (sum * 10) % 11;

      if ((rest == 10) || (rest == 11))  rest = 0;
      if (rest != parseInt(this.lead["cpf"].substring(10, 11) ) ) {
        this.leadFormError["cpf"].state = false;
        return this.leadFormError["cpf"].state;
      }

      this.leadFormError["cpf"].state = true;
    }

    return this.leadFormError["cpf"].state;
  }

  private get detailsState() {
    if (this.lead["details"] != null) {
      this.leadFormError["details"].state =
        this.lead["details"] != "" &&
        this.lead["details"].length > 10 ? true : false;
    }
    return this.leadFormError["details"].state;
  }

  private get orderState() {
    if (this.lead["order"] != null) {
      this.leadFormError["order"].state =
        this.lead["order"] != "" ? true : false;
    }
    return this.leadFormError["order"].state;
  }
  /**
   * Method for validation form add lead
   */
  private validateForm() {
    let mandatoryFields: string[] = [];

    if (this.$auth.user().profile === 'admin' || this.$auth.user().profile === 'management') {
      mandatoryFields = ['name', 'phone', 'details']
    } else if (this.$auth.user().profile === 'operator') {
      mandatoryFields = ['name', 'phone', 'email', 'cpf', 'details']
    }

    for (let elem in this.leadFormError) {
      if (mandatoryFields.includes(elem)) {
        if (this.lead[elem] == null || this.lead[elem] == "") {
          this.leadFormError[elem].state = false;
        }
      }
    }
  }

  /**
   * Method for add new lead
   */
  private async addLead() {
    this.validateForm();

    if (this.$auth.user().profile === 'operator' &&
      (!this.nameState || !this.phoneState || !this.emailState || !this.cpfState || (!this.detailsState && !(this.$auth.user().platform_name == 'nofaro')))) {
      return;
    }
    if ((this.$auth.user().profile === 'admin' || this.$auth.user().profile === 'management') &&
      ((!this.nameState || !this.phoneState) || (!this.detailsState && !(this.$auth.user().platform_name == 'nofaro')))) {
      return;
    } else {
      this.loading = true;
      this.leadService.store(this.lead, this.$auth.user().id_user).then((res: any) => {
        // Business rule: manual lead creation for platform 'bv-fgts' should start with 'Atendimento' instead of 'Lead'
        if (this.$auth.user().platform_name == 'bv-fgts' || this.$auth.user().platform_name == 'bv-fgts-sales') {

        const payloadExport = {
            leadId: res.id_lead,
            // historyId: ,
            channelId: 6,
            userId:this.$auth.user().id_user
        }

        this.leadService.setLeadExport(payloadExport);

          this.channelAutoAttendance = {
            id_channel: 1,
            name: "phone",
            label: "Telefone",
          } // TODO: change for the one used at bv-fgts

          this.tabulationAutoAttendance = {
            fk_id_related_status: 4,
            fk_id_related_channel: 1,
            name: "Atendimento",
          }
        setTimeout(() => {
            this.autoTabulationLead(res.id_lead, true)
        }, 2000);
        }

        if (JSON.stringify(res).indexOf("success") !== -1) {
          this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Lead adicionado com sucesso!');
          this.listLead.ajax.reload();
        } else {
          if (
            (this.$auth.user().platform_name == 'bv-fgts' ||
            this.$auth.user().platform_name == 'bv-fgts-sales') &&
            res.status == 422 &&
            res.message == 'This lead already exists'
          ){
            this.$store.commit("navBarAlert/DANGER_ALERT", 'Erro ao adicionar novo lead. CPF já cadastrado.');
          } else {
            this.$store.commit("navBarAlert/DANGER_ALERT", 'Erro ao adicionar novo lead.');
          }
        }
        this.loading = false;
        this.closeLeadModal();
      });
    }
  }

  /**
   * Method close modal from add new lead
   */
  private closeLeadModal() {
    this.hideModal("modal-add-lead");
    this.lead.name = null;
    this.lead.phone = null;
    this.lead.email = null;
    this.lead.cpf = null;
    this.lead.order = null;
    this.lead.details = null;
    this.lead.action = null;

    this.leadFormError["name"].state = null;
    this.leadFormError["phone"].state = null;
    this.leadFormError["email"].state = null;
    this.leadFormError["cpf"].state = null;
    this.leadFormError["order"].state = null;
    this.leadFormError["details"].state = null;
  }

  /**
   * Method join commands for create datatable
   */
  private createDataTable(vm) {
    let self = this;

    this.buttons.push({ extend: "dispatcherTransshipment" });

    this.buttons.push({
      extend: "colvis",
      text: '<i class="fas fa-list"></i>',
      titleAttr: "Colunas",
      className: "datatable-buttons mr-2 pr-0 pl-0 border-10",
      columns: this.columnsVisible,
    });

    if (vm.allowedFeature('export')) {
      this.buttons.push({
        extend: "collection",
        text: '<i class="fas fa-file-export"></i>',
        titleAttr: "Exportar",
        className: "datatable-buttons mr-2 pr-0 pl-0 border-10",
        autoClose: true,
        buttons: [
          {
            extend: "excelHtml5",
            text: "Excel",
            titleAttr: "Excel",
            exportOptions: {
              columns: ":visible",
            },
            action: async (e, dt, node, config) => {
              this.$bvModal.show("modal-export-data");
              this.$store.commit("exportToPABX/clearExportProgress");
              this.exportFormat = "excelHtml5";
            },
          },
          {
            extend: "csvHtml5",
            text: "CSV",
            titleAttr: "CSV",
            exportOptions: {
              columns: ":visible",
            },
            action: async (e, dt, node, config) => {
              this.$bvModal.show("modal-export-data");
              this.$store.commit("exportToPABX/clearExportProgress");
              this.exportFormat = "csvHtml5";
            },
          },
          {
            extend: "copyHtml5",
            text: "Clipboard",
            titleAttr: "Clipboard",
            exportOptions: {
              columns: ":visible",
            },
          },
        ],
      });
    }

    this.buttons.push({
      extend: "filter",
    });

    // Add lead button 'Adicionar lead'
      if (this.buttons[2].buttons)
        this.buttons[2].buttons.push({
            extend: "pabx",
          text: "Exportar",
          titleAttr: "Exportar",
          exportOptions: {
              columns: ":visible",
          },
        });

       if (vm.allowedFeature('create-lead')) {
        this.buttons.push({ extend: "addLead" });

      /*
      // Create HotLeads button
      if (
        this.$auth.user().platform_name_pabx !== undefined &&
        this.$auth.user().platform_name_pabx !== null
      ) {
        this.buttons.push({
          text: "<i class='fas fa-fire'></i>",
          titleAttr: "HotLeads",
          className: "datatable-buttons ml-2 pr-0 pl-0 border-10",
          action: function (this: any, e, dt, node, config) {
            this.$bvModal.show("modal-hotleads");
          }.bind(this),
        });
      }
      */
    }

    if (vm.allowedFeature('visible-columns')) {
      // create column for control export
      this.columns.push({
        data: "cs_channel-wc-label",
        name: "cs_channel-wc-label",
        title: "Exportado",
        orderable: false,
        defaultContent: "--",
        searchable: true,
        visible: false,
      });
      this.columnsVisible.push(this.columns.length - 1);

      // add column name attendant
      this.columns.push({
        data: "cs_user-wc-name",
        name: "cs_user-wc-name",
        title: "Consultor",
        orderable: false,
        defaultContent: "--",
        searchable: false,
        visible: this.$auth.user().profile !== "operator",
      });
      this.adminOnlyColumns.push("cs_user-wc-name");
      if (this.$auth.user().profile !== "operator") {
        this.columnsVisible.push(this.columns.length - 1);
        this.listAttribute.push({
          name: "cs_user-wc-name",
          label: "Consultor",
        });
      }

      // add column status contact
      this.columns.push({
        data: "pabxf-wc-statusLigacaoDesc",
        name: "pabxf-wc-statusLigacaoDesc",
        title: "Status do contato",
        orderable: true,
        defaultContent: "--",
      });
      this.columnsVisible.push(this.columns.length - 1);
      this.listAttribute.push({
        name: "pabxf-wc-statusLigacaoDesc",
        label: "Status do contato",
      });

      // add column status contact
      this.columns.push({
        data: "pabxf-wc-idStatusLigacao",
        name: "pabxf-wc-idStatusLigacao",
        title: "Id status do contato",
        orderable: true,
        defaultContent: "--",
        searchable: false,
        visible: false,
      });
    }

    // add column attendant evaluation
    this.columns.push({
      data: "cae-wc-evaluation",
      name: "cae-wc-evaluation",
      title: "Avaliação",
      orderable: false,
      defaultContent: "--",
      searchable: false,
      visible: true,
    });
    this.columnsVisible.push(this.columns.length - 1);
    this.listAttribute.push({
      name: "cae-wc-evaluation",
      label: "Avaliação",
    });

    // add column attendant evaluation details
    this.columns.push({
      data: "cae-wc-details",
      name: "cae-wc-details",
      title: "Obs. da avaliação",
      orderable: false,
      defaultContent: "--",
      searchable: false,
      visible: true,
    });
    this.columnsVisible.push(this.columns.length - 1);
    this.listAttribute.push({
      name: "cae-wc-details",
      label: "Obs. da avaliação",
    });

    let visibleColumnsLocalStorage = JSON.parse(localStorage.getItem(
      this.$auth.user().platform_name + "-attributesVisible"
    ) as string);

    if (visibleColumnsLocalStorage) {
      this.columns.forEach((col, key) => {
        if (visibleColumnsLocalStorage.hasOwnProperty(col.data)
          && ((this.$auth.user().profile === "admin" || this.$auth.user().profile === 'management') || !this.adminOnlyColumns.includes(col.data))) {
            col.visible = visibleColumnsLocalStorage[col.data] == true;
            if (col.visible && !this.attributesVisible.includes(col.data) &&
              col.data != "cl-wc-id_lead" &&
              col.data != "cs_user-wc-name" &&
              col.data != "cae-wc-evaluation" &&
              col.data != "cae-wc-details"
            ) {
                this.attributesVisible.push(col.data);
            }
        }
      });
    }

    if(this.$auth.user().profile !== 'operator'){
        this.columns.push({
        data: "clh_lead-wc-referer",
        name: "clh_lead-wc-referer",
        title: "Referer",
        orderable: false,
        });
        this.columns.push({

        data: "clh_lead-wc-origin",
        name: "clh_lead-wc-origin",
        title: "Origem",
        orderable: false,
        defaultContent: "--",
        })
    }

    // init datatable
    this.listLead = this.$("#listLead")
      .on("preXhr.dt", async (e, settings, d) => {})
      .on("xhr.dt", (e, settings, d, xhr) => {
        if (this.listLead.ajax.json() !== undefined) {
          this.totalLeads = this.listLead.ajax.json().recordsTotal;

          // Datatable response: this is difficult to find. DO NOT delete this comment!
          // Changes done here have a high risk of affecting unimaginable places. Good luck!
          // console.info(this.listLead.ajax.json())

          for (let i = 0; i < this.listLead.ajax.json().data.length; i++) {
            if (this.listLead.ajax.json().data[i]["tabulation"] === 'Tabulação APP') {
              this.listLead.ajax.json().data[i]["tabulation"] = '';
            }
          }

          // If phone column exists, will get all phones and listen to export changes with WebSocket
          if (this.listLead.ajax.json().data.length > 0 && this.listLead.ajax.json().data[0].phone) {
            let listedPhones = this.listLead.ajax.json().data.map(a => a.phone);
            this.$store.commit("leadList/LISTED_PHONES", listedPhones);
          }
        }
        if (xhr.status !== 200)
          this.$store.commit("navBarAlert/DANGER_ALERT", 'Erro ao carregar a listagem. Por favor, tente novamente mais tarde.');
      })
      .on("column-visibility.dt", (e, settings, column, state) => {
        let visibleColumnsLocalStorage = JSON.parse(localStorage.getItem(
          this.$auth.user().platform_name + "-attributesVisible"
        ) as string) || {};
        visibleColumnsLocalStorage[this.columns[column].data] = state;
        localStorage.setItem(
          this.$auth.user().platform_name + "-attributesVisible",
          JSON.stringify(visibleColumnsLocalStorage)
        );

        this.attributesVisible = [];
        this.listAttribute.forEach((attr, key) => {
          if (
            this.listLead.column(attr.name + ":name").visible() &&
            attr.name != "cl-wc-id_lead" &&
            attr.name != "cs_user-wc-name" &&
            attr.name != "cae-wc-evaluation" &&
            attr.name != "cae-wc-details"
          ) {
            this.attributesVisible.push(attr.name);
          }
        });
        this.listLead.ajax.reload();
      })
      .DataTable({
        fixedColumns:   {
            leftColumns: 0,
            rightColumns: 1,
        },
        autoWidth: false,
        responsive: true,
        processing: true,
        serverSide: true,
        colReorder: true,
        searchDelay: 1000,
        lengthMenu: [
          vm.allowedFeature('filter-lead-amount') ? [10, 25, 100, 500, 1000, 2000, 3000] : [10, 25, 100, 500],
          vm.allowedFeature('filter-lead-amount') ? [10, 25, 100, 500, "1000", "2000", "3000"] : [10, 25, 100, 500],
        ],
        pageLength: 25,
        scrollY: 500,
        scrollX: true,
        language: {
          sEmptyTable: "Nenhum registro encontrado",
          sInfo: "Mostrando de _START_ até _END_ de _TOTAL_ registros",
          sInfoEmpty: "Mostrando 0 até 0 de 0 registros",
          sInfoFiltered: "(Filtrados de _MAX_ registros)",
          sInfoPostFix: "",
          sInfoThousands: ".",
          sLengthMenu: "_MENU_ Qtd por página",
          sLoadingRecords: "Carregando...",
          sProcessing:
            '<div><div class="row justify-content-center m-5"><span role="status" class="spinner-border" style="width: 3rem; height: 3rem;"></span></div><div class="row justify-content-center mt-5">Loading ...</div></div>',
          sZeroRecords: "Nenhum registro encontrado",
          sSearch: "Pesquisar",
          oPaginate: {
            sNext: "Próximo",
            sPrevious: "Anterior",
            sFirst: "Primeiro",
            sLast: "Último",
          },
          oAria: {
            sSortAscending: ": Ordenar colunas de forma ascendente",
            sSortDescending: ": Ordenar colunas de forma descendente",
          },
          select: {
            rows: {
              _: "Selecionado %d linhas",
              "0": "Nenhuma linha selecionada",
              "1": "Selecionado 1 linha",
            },
          },
        },
        ajax: {
          url: process.env.VUE_APP_ROOT_API + "solution/datatable",
          crossDomain: true,
          type: "POST",
          contentType: "application/json",
          headers: {
            Authorization: `Bearer ${this.$auth.token()}`
          },
          data: (d) => {
            // Datatable payload: this is difficult to find. DO NOT delete this comment!
            // Changes done here have a high risk of affecting unimaginable places. Good luck!
            // console.info(d)

            let parsedData = this.mountedFilter(d);

            // Business Rule
            if (
              this.$auth.user().platform_name === 'cantu' &&
              this.$auth.user().profile === 'operator' &&
              parsedData &&
              parsedData.columns &&
              parsedData.platform_attributes
            ) {
              parsedData.columns = parsedData.columns.filter(obj =>
                obj.data !== 'value' && obj.data !== 'details'
              );

              parsedData.platform_attributes = parsedData.platform_attributes.filter(obj =>
                obj.name !== 'value' && obj.name !== 'details'
              );
            };

            return JSON.stringify(parsedData);
          }
        },
        columns: this.columns,
        columnDefs: [
          {
            className: "nowrap",
            targets: 0,
          },
          {
            className: "nowrap",
            render: (data, type, row) => {

              const dateHotleadWpp = (<any>this.$moment(row['clh_lead-wc-created_at'])).tz("America/Sao_Paulo");
              const dateHotleadSms = (<any>this.$moment(row['clh_lead-wc-created_at'])).tz("America/Sao_Paulo");

              let buttons = "";
              if (vm.allowedFeature('button-channel')) {
                if (this.whatsappChanel && this.$moment().diff(dateHotleadWpp, 'minutes') >= (this.whatsappChanel.delay_export))
                  buttons +=
                    "<button class='whatsappButton' type='button' style='padding: 0; border: 0; background-color: transparent;'><i class='fab fa-whatsapp'></i></button>&nbsp;";

                if (this.smsChannel && this.$moment().diff(dateHotleadSms, 'minutes') >= (this.smsChannel.delay_export))
                  buttons +=
                    "<button class='smsButton' type='button' style='padding: 0; border: 0; background-color: transparent;'><i class='fas fa-sms'></i></button>&nbsp;";

              }
              if (!vm.allowedFeature('visible-info-full')) {
                data = data ? data.substring(0, data.length - 4) + "..." : "";
              }

              return buttons + data;
            },
            targets: 3,
          },
          {
            className: "nowrap",
            render: (data, type, row) => {
              if (!vm.allowedFeature('visible-info-full')) {
                data = data ? data.substring(0, 10) + "..." : "";
              }
              return data;
            },
            targets: 4,
          },
          {
            className: "nowrap",
            targets: 6,
          },
          {
            className: "nowrap",
            targets: 11,
          },
          {
            className: "nowrap",
            targets: 10,
          },
          {
            render: (data, type, row) => {
              if (row["clh_last-wc-fk_id_status"] == 1) {
                return (
                  '<div class="column-status-lead"><span class="font-status-white">' +
                  data +
                  "</span><div class='icon-status-lead'></div></div>"
                );
              }
              if (row["clh_last-wc-fk_id_status"] == 3) {
                return (
                  '<div class="column-status-conversion"><span class="font-status">' +
                  data +
                  "</span><div class='icon-status-conversion'></div></div>"
                );
              }
              if (row["clh_last-wc-fk_id_status"] == 4) {
                return (
                  '<div class="column-status-call"><span class="font-status-dark-blue">' +
                  data +
                  "</span><div class='icon-status-call'></div></div>"
                );
              }
              if (row["clh_last-wc-fk_id_status"] == 5) {
                return (
                  '<div class="column-status-sale"><span class="font-status">' +
                  data +
                  "</span><div class='icon-status-sale'></div></div>"
                );
              }
              if (row["clh_last-wc-fk_id_status"] == 8) {
                return (
                  '<div class="column-status-self-sale"><span class="font-status-white">' +
                  data +
                  "</span><div class='icon-status-sale'></div></div>"
                );
              }
               if (row["clh_last-wc-fk_id_status"] == 16) {
                return (
                  '<div class="column-status-refusal"><span class="font-status">' +
                  data +
                  "</span><div class='icon-status-sale'></div></div>"
                );
              }
               if (row["clh_last-wc-fk_id_status"] == 15) {
                return (
                  '<div class="column-status-scheduling"><span class="font-status">' +
                  data +
                  "</span><div class='icon-status-sale'></div></div>"
                );
              }
              if (row["clh_last-wc-fk_id_status"] == 23) {
                return (
                  '<div class="column-status-unproductive"><span class="font-status">' +
                  data +
                  "</span><div class='icon-status-sale'></div></div>"
                );
              }
               if (row["clh_last-wc-fk_id_status"] == 50) {
                return (
                  '<div class="column-status-worked"><span class="font-status">' +
                  data +
                  "</span><div class='icon-status-worked-call'></div></div>"
                );
              }
              if (row["clh_last-wc-fk_id_status"] == 56) {
                return (
                  '<div class="column-status-input"><span class="font-status">' +
                  data +
                  "</span><div class='icon-status-worked-call'></div></div>"
                );
              }
              return (
                '<div class="column-status-lead"><span class="font-status-white">' +
                data +
                "</span><div class='icon-status-lead'></div></div>"
              );
            },
            targets: 7,
          },
          {
            title: "Ações",
            orderable: false,
            className: "nowrap",
            width: "auto",
            right: 1,
            position: "relative",
            render: (data, type, row) => {
              let icons = '';
              if (vm.allowedFeature('reset-lead'))
                icons += "<a class=\"btnResetLead\" style=\"color: #dc3545;\"><i class='fas fa-reply'></i></a>";

              if(row['cs_user-wc-name'] === this.$auth.user().name || vm.allowedFeature('app-chat'))
                icons += " <a class=\"btn-show-message-app\" style=\"color: #172542;\"><i class='far fa-comment-dots fa-lg'></i></a>";

              icons += "<a class=\"leadJourney ml-1\"><i class='fas fa-eye fa-lg' style='color: #172542;'></i></a>";

              if (vm.allowedFeature('lead-tabulation')) {
                icons += " <a class=\"btn-auto-tabulation-lead\" style=\"color: #172542;\"><i class='far fa-calendar-plus fa-lg'></i></a>";
                icons +=
                  " <a href='/lead/" +
                  row["cl-wc-id_lead"] +
                  "' style=\"color: #172542;\"><i class='fas fa-edit fa-lg'></i></a>";
              }

              if (this.$auth.user().platform_name === 'bv-fgts-app') {
                icons += " <a class='btn-bv-fgts-offer' style='color: #172542;'><i class='fas fa-dollar-sign fa-lg mr-1'></i></a>";
              }

              if ((
                    (vm.allowedFeature('delete-lead')) ||
                    (
                        row['cs_user-wc-name'] === this.$auth.user().name &&
                        this.$auth.user().profile === 'operator' &&
                        this.$moment(this.$moment()).diff(new Date(row['clh_last-wc-created_at']), 'minute') <= 5 &&
                        this.$moment(new Date(row['clh_last-wc-created_at'])).format('DD') == this.$moment().format('DD')
                    )
                  ) && row['cs_status-wc-label'] !== 'Lead') {
                icons += " <a class=\"btnDeletedHistoryLead\" style=\"color: #dc3545;\"><i class='fas fa-trash-alt fa-lg'></i></a>";
              }

              return icons;
            },
            targets: this.columns.length,
          },
          {
            render: (data, type, row, meta) => {
              if (
                this.columns[meta.col].data == "date_renovation" ||
                this.columns[meta.col].data == "date_sale" ||
                this.columns[meta.col].data == "date_scheduling" ||
                this.columns[meta.col].data == "clh_last-wc-created_at" ||
                this.columns[meta.col].data == "cl_export-wc-worked_at" ||
                this.columns[meta.col].data == "clh_lead-wc-created_at"
              ) {
                if (!data) return data;
                return (<any>this.$moment(data))
                  .tz("America/Sao_Paulo")
                  .format("DD/MM/YYYY HH:mm:ss");
              }

              else if (this.columns[meta.col].data === "cpf" && !vm.allowedFeature('visible-info-full')) {
                data = data ? data.substring(0, 4) + "..." : "";
              }

              else if (this.columns[meta.col].data === "clh_last-wc-fk_id_action") {
                self.actionPlatform.find((e: any) => {
                  if(e.id_action == data)
                    data = e.label;
                });
              }

              if(this.columns[meta.col].data === "cnpj" && this.$auth.user().profile === 'operator' )
                data = '--'

              return data;
            },
            targets: "_all",
          },
        ],
        order: [[0, "desc"]],
        dom:
          '<"row"<"pl-3"l>>Brt<"row"<"col-sm-12 col-md-5"i><"col-sm-12 col-md-7"p>>',
        buttons: this.buttons,
        drawCallback: () => {
          this.onTableDraw();

          vm.leanPaging();
        },
      });

    this.listLead.buttons().container().appendTo("#dt-actions")

    if (
      localStorage.getItem(
        this.$auth.user().platform_name + "-attributesVisible"
      )
    ) {
      let visibleColumnsLocalStorage = {};
      this.columns.map((col: any) => {
        visibleColumnsLocalStorage[col.data] = col.visible;
      });
      localStorage.setItem(
        this.$auth.user().platform_name + "-attributesVisible",
        JSON.stringify(visibleColumnsLocalStorage)
      );
    }
  }

  /**
   * Method for show modal to confirm export leads to pabx
   */
  private showModalPABX(idsExports: any = []) {
    const h = this.$createElement;

    const messageVNode = h("div", {}, [
      h("p", {}, [
        " Os leads ",
        h("span", { class: ["bold-modal"] }, "(" + idsExports.join(", ") + ")"),
        " já foram exportados para o PABX, deseja exportar novamente ?",
      ]),
    ]);

    return this.$bvModal.msgBoxConfirm([messageVNode], {
      title: "Confirmar exportação (PABX)",
      size: "md",
      buttonSize: "md",
      okVariant: "success",
      okTitle: "Sim",
      cancelTitle: "não",
      footerClass: "p-2 btn-ok",
      hideHeaderClose: true,
      centered: true,
    });
  }

  /**
   * Method that integrate leads with PABX, using the integration microservice
   */
  async exportLeads() {
    if (this.restRule < 0)
        return false;

    this.modalLoading = true;
    let exportHistoryIds = this.listLead
      .column("clh_lead-wc-id_lead_history:name")
      .data();

    const historyIds = Array.from(exportHistoryIds).filter((e) => typeof e === 'number');

    console.log(this.selectedChannelExport.name);

    if(['autonomous', 'mass_approach', 'chatwoot'].includes(this.selectedChannelExport.name)){
        const uniqueHistoryIds = [...new Set(historyIds)];
        let payload: any = {
            type: this.selectedChannelExport.name,
            historyIds: uniqueHistoryIds,
        }

          this.appService.dispatcherTransshipment(payload).then((res) => {
                JSON.stringify(res).includes("success") ?
                    this.$store.commit("navBarAlert/SUCCESS_ALERT", "Leads enviados para fila!") :
                    this.$store.commit("navBarAlert/DANGER_ALERT", `Erro ao fazer ao enviar leads para fila.`);
            }).catch((err) => {
                console.log(err)
                this.modalLoading = false;
                this.$store.commit("navBarAlert/DANGER_ALERT", `Ocorreu um erro inesperado, tente novamente`);
                this.$bvModal.hide('modal-dispatcher-transshipment');
            });

    }else{
        let payload:any = {
            historyIds: historyIds,
            channels: [this.selectedChannelExport.name],
            exportEvenIfAlreadyContactedToday: this.exportEvenIfAlreadyContactedToday
        };

        if(this.selectedChannelExport.name === 'app'){
            if(!!this.overflow){
                payload.overflow = true;
                payload.overflow_time = parseInt(this.overflow);
            }

            if(this.userSelected)
                payload.userId = this.userSelected.id_user;

        }else{
            payload.fromFront = true;

            if(this.selectedPabxLot.pabx_lot_id)
                payload.pabx_lot_id = this.selectedPabxLot.pabx_lot_id;

            if(this.replaceRestRuleLeads)
                payload.is_priority = this.replaceRestRuleLeads;

            if(this.restRule)
                payload.rest_rule = this.restRule * 24;
        }

        if(historyIds.length > 500){

            const arraysHitsotyId:any = historyIds.reduce((accumulator:any, item, indice) => {
                const group = Math.floor(indice / 500);
                accumulator[group] = [...(accumulator[group] || []), item];
                return accumulator;
            }, [])

            for (const iterator of arraysHitsotyId) {
                payload.historyIds = iterator;
                await this.leadService.leadExportQueue(payload);
            }

            this.$store.commit("navBarAlert/SUCCESS_ALERT", "Leads exportado com sucesso!");
        }else{
            this.leadService.leadExportQueue(payload).then((result) => {
                if(result.errorsCount > 0){
                    this.$store.commit("navBarAlert/WARNING_ALERT", "Falha ao exporta os leads!");
                }else{
                    this.$store.commit("navBarAlert/SUCCESS_ALERT", "Leads exportado com sucesso!");
                }
            }).catch((err) => {
                this.$store.commit("navBarAlert/DANGER_ALERT", "Erro ao exporta os leads!");
                this.modalLoading = false;
                this.closeExportModal();
            });
        }

    }
    this.modalLoading = false;
    this.closeExportModal()

    // Export no used SQS
    if(false){
        let chunks: [[any?]?] = [];
        let chunkSize = this.replaceRestRuleLeads
            ? Number(process.env.VUE_APP_PABX_CHUNK_SIZE) / 2
            : Number(process.env.VUE_APP_PABX_CHUNK_SIZE);

        // Dividing leads into chunks
        for (let i = 0, counter = 0, chunk = 0; exportHistoryIds[i]; i++) {
            if (!chunks[chunk]) chunks[chunk] = [];

            chunks[chunk]!.push(exportHistoryIds[i]);
            this.$store.commit("exportToPABX/incrementExportsCounterTotal");
            counter++;

            if (counter == chunkSize) {
                chunk++;
                counter = 0;
            }
        }

        this.exportChunks = chunks;
        this.$store.commit("exportToPABX/setChunksAmount", chunks.length);
    }
  }

  private async onExportResponseReceived(value: number, oldValue: number) {
    // if (oldValue !== 0) {
    let chunk = this.exportChunks.pop();
    if (this.$store.getters["exportToPABX/chunksAmount"] > 0 && chunk) {
      try {
        let pabxService = new PabxService();
        let response = await pabxService.sendToPabx(
          chunk,
          this.selectedPabxLot.pabx_lot_id,
          this.replaceRestRuleLeads,
          this.restRule * 24
        );
      } catch (err) {
        this.$store.commit(
          "exportToPABX/incrementExportsCounterError",
          chunk.length
        );
        this.$store.commit("exportToPABX/incrementExportStatusAmount", {
          status: "msError",
          amount: chunk.length,
        });
      }
    }
    // }
  }

  private async dispatcherTransshipment(message: string) {
    this.modalLoading = true;
    const exportHistoryIdsArray = this.listLead
      .column("clh_lead-wc-id_lead_history:name")
      .data();

    const historyIds = Array.from(exportHistoryIdsArray).filter((e) => typeof e === 'number');
    const uniqueHistoryIds = [...new Set(historyIds)];

    let payload:any = {
        type: "follow_up",
        historyIds: uniqueHistoryIds,
        message: message,
    };

    try{
        if(uniqueHistoryIds.length > 500){

            const arraysHitsotyId:any = uniqueHistoryIds.reduce((accumulator:any, item, indice) => {
                const group = Math.floor(indice / 500);
                accumulator[group] = [...(accumulator[group] || []), item];
                return accumulator;
            }, [])

            for (const iterator of arraysHitsotyId) {
                payload.historyIds = iterator;
                await this.appService.dispatcherTransshipment(payload);
            }

            this.$store.commit("navBarAlert/SUCCESS_ALERT", "Disparo realizado com sucesso!");
        }else{
            this.appService.dispatcherTransshipment(payload).then((res) => {
                JSON.stringify(res).includes("success") ?
                    this.$store.commit("navBarAlert/SUCCESS_ALERT", "Disparo realizado com sucesso!") :
                    this.$store.commit("navBarAlert/DANGER_ALERT", `Erro ao fazer o Disparo`);
            }).catch((err) => {
                console.log(err)
                this.modalLoading = false;
                this.$store.commit("navBarAlert/DANGER_ALERT", `Ocorreu um erro inesperado, tente novamente`);
                this.$bvModal.hide('modal-dispatcher-transshipment');
            });
        }

     } catch (error) {
         console.log(error)
        this.modalLoading = false;
        this.$store.commit("navBarAlert/DANGER_ALERT", `Ocorreu um erro inesperado, tente novamente`);
        this.$bvModal.hide('modal-dispatcher-transshipment');
    }

    this.modalLoading = false;
    this.$bvModal.hide("modal-dispatcher-transshipment");
  }

  private exportChunks: [[any?]?] = [];
  private duplicatedExport: boolean = false;
  private duplicatedExportIds: [string?] = [];
  private pabxLots: [any?] = [];
  private selectedPabxLot: any = null;
  private selectedChannelExport: any = null;
  private restRule = 30;
  private replaceRestRuleLeads: boolean = false;

  /**
   * Method close modal from add new lead
   */
  private closeExportModal() {
    this.hideModal("modal-export");
    this.duplicatedExport = false;
    this.duplicatedExportIds = [];
    this.pabxLots = [];
    this.$store.commit("exportToPABX/clearExportProgress");
    this.selectedPabxLot = null;
    this.replaceRestRuleLeads = false;
    this.restRule = 30;
    this.exportEvenIfAlreadyContactedToday = false;
    this.selectedChannelExport = null;
    this.overflow = null;
    this.userSelected = null;
  }

  private closeExportDataModal() {
    this.hideModal("modal-export-data");
    this.$store.commit("exportToPABX/clearExportProgress");
  }

  /**
   * Method mounted from life cycle
   */
  private mounted() {
    let self = this;

    this.$.fn.dataTable.ext.buttons.filter = {
      text: '<i class="fas fa-filter"></i>',
      className: "datatable-buttons mr-2 pr-0 pl-0",
      titleAttr: "Filtrar",
      action: function (e, dt, node, config) {
        if(localStorage.getItem("checkbox-filter"))
          self.filter.checkboxFilters = JSON.parse(localStorage.getItem("checkbox-filter") as string);

        if(localStorage.getItem("attribute-filter"))
          self.filter.attribute = JSON.parse(localStorage.getItem("attribute-filter") as string);
        self.$bvModal.show("modal-filter");
      },
    };

    this.$.fn.dataTable.ext.buttons.dispatcherTransshipment = {
        text: '<i class="fa fa-paper-plane"></i>',
        className: "datatable-buttons mr-2 ml-3 pr-0 pl-0 border-10 dispatcher-transshipment",
        titleAttr: "FUP",
        action: async function (e, dt, node, config) {
            self.modalLoading = true;
            self.$bvModal.show("modal-dispatcher-transshipment");
            console.log(self.filter.id_action[0]);

            self.getMessageResponse = await (new saasService()).getTemplateMessage(
                    self.$auth.user().id_platform
                )
            self.modalLoading = false;
        },
    };

    this.$.fn.dataTable.ext.buttons.addLead = {
      text: '<i class="fas fa-user-plus"></i>',
      className: "datatable-buttons pr-0 pl-0",
      titleAttr: "Adicionar lead",
      action: function (e, dt, node, config) {
        if (self.actionPlatform.length > 0) self.lead.action = (self.actionPlatform[0] as any).name;
        self.$bvModal.show("modal-add-lead");
      },
    };

    this.$.fn.dataTable.ext.buttons.pabx = {
      extend: "csvHtml5",
      text: "PABX",
      action: (e, dt, node, config) => {
        this.modalLoading = true;
        let pabxService = new PabxService();
        pabxService.lotsIndex().then((lots) => {
          this.pabxLots = lots;
          if (this.pabxLots.length > 0) this.selectedPabxLot = this.pabxLots[0];
          this.modalLoading = false;
        });

        this.listLead.rows().iterator("row", (context, index) => {
          if (
            this.listLead.row(index).column("cs_channel-wc-label:name").data()[
              index
            ] == "Exportado"
          ) {
            this.duplicatedExportIds!.push(
              this.listLead.row(index).column("cl-wc-id_lead:name").data()[
                index
              ]
            );
          }
        });

        if (this.duplicatedExportIds.length > 0) this.duplicatedExport = true;

        this.$bvModal.show("modal-export");
      },
    };
  }

  private hotLeadParams: any | null = {};
  private hotLeads: Array<any> | null = [];
  private hotLeadsModalLoadingFlag: boolean = false;
  private hotLeadsModalShow() {
    this.hotLeadParams = null;
    this.hotLeads = null;
    this.leadService
      .hotLeadParams(this.$auth.user().id_platform)
      .then((result) => {
        this.hotLeadParams = result;

        this.leadService
          .hotLeads(this.$auth.user().id_platform)
          .then((result) => {
            for (let hotLead of result) {
              hotLead.vmodel = {
                channel: this.hotLeadParams.channel[hotLead.id_channel],
                condition: this.hotLeadParams.condition[
                  hotLead.id_hot_lead_condition
                ],
                attribute: this.hotLeadParams.attribute[hotLead.attribute_name],
              };
            }
            this.hotLeads = result;
          });
      });
  }

  private get isHotLeadsModalLoading() {
    return (
      this.hotLeadParams === null ||
      this.hotLeads === null ||
      this.hotLeadsModalLoadingFlag
    );
  }

  private get isLeadJourneyModalLoading() {
    return (
      Object.keys(this.leadAllFields).length <= 0 ||
      this.leadHistory.length <= 0
    );
  }

  private async getUserSquad(){
      const userService = new UserService()
      const listUser:any = await userService.userList(this.$auth.user().id_platform)
      this.user_squad = listUser.body.filter((e:any) => e.status == "usuario ativo");
  }

  private newHotLead() {
    this.hotLeads!.push({
      vmodel: {
        channel: null,
        condition: null,
        attribute: null,
      },
    });
  }

  private sendHotLeads() {
    this.showSuccessAlert = false;
    this.showDangerAlert = false;
    this.hotLeadsModalLoadingFlag = true;

    this.leadService
      .setHotLeads(this.$auth.user().id_platform, this.hotLeads)
      .then((result) => {
        this.hotLeadsModalLoadingFlag = false;
        this.hideModal("modal-hotleads");
        if (result[0] == null) {
          // Sucesso
          this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Regras de HotLeads definidas com sucesso.');
        } else {
          // Erro
          this.$store.commit("navBarAlert/SUCCESS_ALERT", result[0]);
        }
      });
  }

  private clearHotLeads() {
    this.hotLeads = [];
  }

  /**
   * @type string
   * Whatsapp message
   */
  private whatsappMessage: string = "";

  private selectedContact = {
    cleverId: undefined,
    historyId: undefined,
    contactName: undefined,
    name_pet: undefined,
    phoneNumber: "",
    attendantId: this.$auth.user().id_user
  };

  private selectedRow: any = null;

  private whatsAppAlreadySentBy: { id_user: number|null, name: number|null, created_at: string } | null = null;
  private wppSentOnXDays: string | null = null;

  private leanPaging() {
    if (this.allowedFeature('lean-paging')) {
      this.$('#listLead_info, .dataTables_paginate .paginate_button:not(.previous):not(.next)').hide();
    }
  }

  private updateLeadStatus (statusCode: number, statusLabel: string) {
    this.selectedRow.data({
      ...this.selectedRow.data(),
      'clh_last-wc-fk_id_status': statusCode,
      'cs_status-wc-label': statusLabel
    });
  }

  private sendWhatsapp(sendEvenIfAlreadySent?: boolean) {
    this.modalLoading = true;

    let requestBody: any = {
      cleverId: this.selectedContact.cleverId,
      historyId: this.selectedContact.historyId,
      phoneNumber: this.selectedContact.phoneNumber,
      name: this.selectedContact.contactName,
      text: this.whatsappMessage,
      idPlatform: this.$auth.user().id_platform,
      attendantWhatsappId: this.$auth.user().id_zapguru,
      attendantId: this.$auth.user().id_user
    };

    if (sendEvenIfAlreadySent === true)
      requestBody.sendEvenIfAlreadySent = true;

    let message: string;
    let messageGuru: string;
    let response = this.whatsappService
      .sendWhatsapp(requestBody)
      .then(
        (result) => {
          message = (requestBody.sendMessage !== false) ? "Mensagem enviada!" : "Abrindo janela do WhatsApp!"
          this.$store.commit("navBarAlert/SUCCESS_ALERT", message );

          messageGuru = (requestBody.sendMessage !== false) ? "Mensagem enviada!" : "Abrindo janela do WhatsApp!"
          this.$store.commit("navBarAlert/SUCCESS_ALERT", messageGuru );

          // tratando 55
          this.selectedContact.phoneNumber = this.selectedContact.phoneNumber.replace(/\D+/g, "");

          if (this.selectedContact.phoneNumber.length >= 10 && this.selectedContact.phoneNumber.length < 12)
              this.selectedContact.phoneNumber = `+55${this.selectedContact.phoneNumber}`;
          else if (this.selectedContact.phoneNumber.length >= 12 && !this.selectedContact.phoneNumber.startsWith('550'))
              this.selectedContact.phoneNumber = `+${this.selectedContact.phoneNumber}`;
          else
              this.selectedContact.phoneNumber = this.selectedContact.phoneNumber.replace(/^550/, '+55');

          //removendo digito nove
          let ddd = Number(this.selectedContact.phoneNumber.substring(3, 5));
          if (this.selectedContact.phoneNumber.length === 14 && this.selectedContact.phoneNumber.startsWith('+55') && ddd > 30) {
            this.selectedContact.phoneNumber = `${this.selectedContact.phoneNumber.substring(0, 5)}${this.selectedContact.phoneNumber.substring(6, 14)}`;
          }
          if (this.selectedContact.phoneNumber.length === 13 && this.selectedContact.phoneNumber.startsWith('+55') && ddd < 30) {
            this.selectedContact.phoneNumber = `${this.selectedContact.phoneNumber.substring(0, 5)}9${this.selectedContact.phoneNumber.substring(5, 13)}`;
          }

          if (result.data.zapguru === false) {
            window.open(`https://api.whatsapp.com/send?phone=${this.selectedContact.phoneNumber}&text=${encodeURIComponent(this.whatsappMessage)}`,"_blank");
          }

          this.updateLeadStatus(50, 'Trabalhado');

          this.closeWhatsappModal();
        },
        (error) => {
          if (error.body.user) {
            this.whatsAppAlreadySentBy = error.body.user;
            let messageDate = this.$moment.utc(this.whatsAppAlreadySentBy!.created_at as any);
            let messageTimeBRT = this.$moment(messageDate).subtract(3, 'hours').format("HH:mm");
            let today = this.$moment().startOf('day').utc();
            let yesterday = this.$moment().subtract(1, 'day').startOf('day').utc();

            if (messageDate.diff(today, 'seconds') >= 0) { // Message sent today
            //   this.wppSentOnXDays = `hoje as ${ messageTimeBRT }`;
              this.wppSentOnXDays = `hoje `;
            } else if (messageDate.diff(yesterday, 'seconds') >= 0) { // Message sent yesterday
            //   this.wppSentOnXDays = `ontem as ${ messageTimeBRT }`;
              this.wppSentOnXDays = `ontem `;
            } else {
              let difference = Math.ceil(today.diff(messageDate, 'seconds') / 86400.0);
              this.wppSentOnXDays = `a ${difference} dias`;
            }
          } else {
            this.$store.commit("navBarAlert/DANGER_ALERT", error.body.message || error.body.description || "Erro ao enviar mensagem");
            this.closeWhatsappModal();
          }
        }
      )
      .finally(() => {
        this.modalLoading = false;
      });
  }

  private closeWhatsappModal() {
    this.whatsappMessage = "";
    this.whatsAppAlreadySentBy = null;
    this.hideModal('modal-whatsapp');
  }

  private smsMessage = "";

  private async sendSms() {
    this.modalLoading = true;
    let response = await this.smsService
      .sendSms(this.selectedContact, this.smsMessage)
      .then(
        (result) => {
          this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Mensagem enviada!');
        },
        (error) => {
          this.$store.commit("navBarAlert/DANGER_ALERT", error.body);
        }
      );

    this.updateLeadStatus(50, 'Trabalhado');

    this.hideModal("modal-sms");
    this.modalLoading = false;
  }

  private hideModal(modal_id: string) {
    this.$bvModal.hide(modal_id);
  }

  /**
   * Method before create from life cycle
   */
  private beforeCreate() {
    document.body.className = "";
  }

  private deletedHistoryLead() {
    this.loading = true;
    this.leadService.deletedHistory(this.deleteIdleadHistory)
        .then((response) => {
            if(response.status === 200){
              this.$store.commit("navBarAlert/SUCCESS_ALERT", "Tabulação foi excluida com sucesso!");
              this.listLead.ajax.reload();
            }else{
              this.$store.commit("navBarAlert/DANGER_ALERT", 'Erro ao apagar a tabulação. Por favor, tente novamente mais tarde.');
              this.listLead.ajax.reload();
            }
        });

    this.$bvModal.hide("modal-deleted-history-lead");
    this.loading = false;
  }

   private resetHistoryLead() {
    this.loading = true;
    this.leadService.resetLead(this.resetIdlead)
        .then((response) => {
            this.$store.commit("navBarAlert/SUCCESS_ALERT", "Reset feito com sucesso!");
            this.listLead.ajax.reload();
        });

    this.$bvModal.hide("modal-reset-history-lead");
    this.loading = false;
  }

  /*
  * status
  * 17 => "tabulation_active"
  *  4 => "lead_customer_service_started"
  */
  private async channelSelectedAutoAttendence(channel: any) {
    if (this.channelAutoAttendance && this.channelAutoAttendance != null && this.channelAutoAttendance.fk_id_channel) {
      const leadTabulationService: LeadTabulationService = new LeadTabulationService();
      this.tabulationsAttendeceOptions = await leadTabulationService.indexAllFilters(17,4,this.channelAutoAttendance.fk_id_channel);
      this.tabulationsAttendeceOptions = [
        ...this.tabulationsAttendeceOptions,
        ...await leadTabulationService.indexAllFilters(17,15,this.channelAutoAttendance.fk_id_channel)
      ];
    }
  }

  private async autoTabulationLead(id_lead, created_lead?) {
    this.loading = true;

    let payload:any = {
        channel: this.channelAutoAttendance,
        tabulation: this.tabulationAutoAttendance,
    };

    if(this.tabulationAutoAttendance.fk_id_related_status  !== 4)
        payload.date_scheduling = this.date_scheduling;

    try {
        if(created_lead && (this.$auth.user().platform_name == 'bv-fgts' || this.$auth.user().platform_name == 'bv-fgts-sales')){
            payload.status = { id_status: 50, name: "lead_worked", label: "Trabalhado"}

            await this.leadService.newHistory(id_lead, payload).then((res) => {
                JSON.stringify(res).includes("success") ?
                    this.$store.commit("navBarAlert/SUCCESS_ALERT", "Trabalhado salvo com sucesso!") :
                    this.$store.commit("navBarAlert/DANGER_ALERT", `Erro ao tabular lead como Trabalhado`);
            });

            await setTimeout(async () => {
                payload.status = {
                    id_status: 4,
                    name: this.tabulationAutoAttendance.fk_id_related_status  == 4 ? "lead_customer_service_started" : 'lead_scheduled',
                    label: this.tabulationAutoAttendance.fk_id_related_status  == 4 ? "Atendimento" : "Agendamento",
                }

                await this.leadService.newHistory(id_lead, payload).then((response) => {
                    JSON.stringify(response).includes("success") ?
                        this.$store.commit("navBarAlert/SUCCESS_ALERT", "Atendimento salvo com sucesso!") :
                        this.$store.commit("navBarAlert/DANGER_ALERT", `Erro ao tabular lead como atendimento`);

                    this.listLead.ajax.reload();
                });
            }, 2000);
        }else {
            payload.status = {
                id_status: this.tabulationAutoAttendance.fk_id_related_status,
                name: this.tabulationAutoAttendance.fk_id_related_status  == 4 ? "lead_customer_service_started" : 'lead_scheduled',
                label: this.tabulationAutoAttendance.fk_id_related_status  == 4 ? "Atendimento" : "Agendamento",
            }

            await this.leadService.newHistory(id_lead, payload).then((response) => {
                JSON.stringify(response).includes("success") ?
                    this.$store.commit("navBarAlert/SUCCESS_ALERT", "Atendimento salvo com sucesso!") :
                    this.$store.commit("navBarAlert/DANGER_ALERT", `Erro ao tabular lead como atendimento`);

                this.listLead.ajax.reload();
            });
        }
    } catch (error) {
        console.log(error)
        this.listLead.ajax.reload();
        this.$store.commit("navBarAlert/DANGER_ALERT", `Ocorreu um erro inesperado, tente novamente`);
    }

    this.channelAutoAttendance = null;
    this.tabulationAutoAttendance = {};
    this.$bvModal.hide("modal-auto-tabulation-lead");
    this.loading = false;
  }

  // Listen to changes on export status of leads on the lead list.
  // State on VueX will be changed by an action called with WebSocket.
  private get updatedLeadExportLabel() {
    return this.$store.getters['leadList/updatedLeadExportLabel'];
  }
  @Watch("updatedLeadExportLabel")
  private onUpdatedLeadListExportStatusChange(val: any, oldVal: any) {
    if (val) {
      let rowsData = this.listLead.rows().data();
      for (let i = 0; i < this.listLead.rows().data().length; i++) {
        if (rowsData[i].phone === val.phone) {
          rowsData[i]['cs_channel-wc-label'] = val.text;
        }
      }
      this.listLead.rows().invalidate(); // Re-render list without making another ajax request
      this.onTableDraw();
    }
  }

  private onTableDraw() {
    this.$(".whatsappButton").click((e) => {
      this.selectedRow = this.listLead.row(this.$(e.target).closest('tr'));

      this.selectedContact.contactName = this.selectedRow.data().name;
      this.selectedContact.phoneNumber = this.selectedRow.data().phone;
      this.selectedContact.cleverId = this.selectedRow.data()["cl-wc-id_lead"];
      this.selectedContact.historyId = this.selectedRow.data()["clh_lead-wc-id_lead_history"];

      let visibleColumnsLocalStorage = JSON.parse(localStorage.getItem(
        this.$auth.user().platform_name + "-attributesVisible"
      ) as string);

      this.selectedContact.name_pet = undefined;
      if (this.$auth.user().platform_name == "petiko" && this.selectedRow.data()["name_pet"] && visibleColumnsLocalStorage.name_pet) {
          this.selectedContact.name_pet = this.listLead
              .row(this.$(e.target)
              .parents("tr")).data()["name_pet"];
      }

      this.$bvModal.show("modal-whatsapp");
    });

    this.$(".smsButton").click((e) => {
      this.selectedRow = this.listLead.row(this.$(e.target).closest('tr'));

      this.selectedContact.contactName = this.selectedRow.data().name;
      this.selectedContact.phoneNumber = this.selectedRow.data().phone;
      this.selectedContact.cleverId = this.selectedRow.data()["cl-wc-id_lead"];
      this.selectedContact.historyId = this.selectedRow.data()["clh_lead-wc-id_lead_history"];

      if (this.$auth.user().platform_name == "pravaler") {
        this.smsMessage =
          "PraValer: Oi! Segue o link para envio dos documentos que conversamos pelo telefone: https://bit.ly/pravalerchat";
      } else {
        this.smsMessage = "";
      }
      this.$bvModal.show("modal-sms");
    });

    this.$(".leadJourney").click((e) => {
      this.leadAllFields = {};
      this.leadHistory = [];
      this.leadService
        .show(
          this.listLead.row(this.$(e.target).parents("tr")).data()[
            "cl-wc-id_lead"
          ]
        )
        .then((response) => {
          this.leadAllFields = response;
        });

      this.leadService
        .historyIndex(
          this.listLead.row(this.$(e.target).parents("tr")).data()[
            "cl-wc-id_lead"
          ]
        )
        .then((response) => {
          this.leadHistory = response.length > 0 ? response : [0];
        });
      this.$bvModal.show("modal-lead-journey");
    });

    this.$(".btnDeletedHistoryLead").click((e) => {
        this.deleteIdleadHistory = this.listLead.row(this.$(e.target).parents("tr")).data()["clh_last-wc-id_lead_history"];
        this.modalLead = this.listLead.row(this.$(e.target).parents("tr")).data()["cl-wc-id_lead"];
        this.modalName = this.listLead.row(this.$(e.target).parents("tr")).data()["name"];
        this.modalStatus = this.listLead.row(this.$(e.target).parents("tr")).data()["cs_status-wc-label"];

        this.$bvModal.show("modal-deleted-history-lead");
    });

    this.$(".btnResetLead").click((e) => {
        this.resetIdlead = this.listLead.row(this.$(e.target).parents("tr")).data()["cl-wc-id_lead"];
        this.modalLead = this.listLead.row(this.$(e.target).parents("tr")).data()["cl-wc-id_lead"];
        this.modalName = this.listLead.row(this.$(e.target).parents("tr")).data()["name"];
        this.modalStatus = this.listLead.row(this.$(e.target).parents("tr")).data()["cs_status-wc-label"];

        this.$bvModal.show("modal-reset-history-lead");
    });

    this.$(".btn-auto-tabulation-lead").click((e) => {
        this.modalLead = this.listLead.row(this.$(e.target).parents("tr")).data()["cl-wc-id_lead"];
        this.$bvModal.show("modal-auto-tabulation-lead");
    });

    this.$(".btn-bv-fgts-offer").click((e) => {
        this.modalLead = this.listLead.row(this.$(e.target).parents("tr")).data()["cl-wc-id_lead"];
        this.toggleFgtsOfferModal();
    });

    this.$(".btn-show-message-app").click((e) => {
        this.modalLeadMessage = this.listLead.row(this.$(e.target).parents("tr")).data()["cl-wc-id_lead"];
        this.modalLeadHistory = this.listLead.row(this.$(e.target).parents("tr")).data()["clh_last-wc-id_lead_history"];
        this.modalStatus = this.listLead.row(this.$(e.target).parents("tr")).data()["cs_status-wc-label"];
        this.$bvModal.show("modal-message-app");
    });
  }

  private isFgtsOfferModalVisible = false;

  private toggleFgtsOfferModal() {
    this.isFgtsOfferModalVisible = !this.isFgtsOfferModalVisible;
  }
}
